<template>
  <div>
    <v-container class="payment-method-container">
      <v-row no-gutters>
        <v-col :cols="$vuetify.breakpoint.xs ? 12 : 6" class="pa-0 mt-3">
          <v-row class="pa-0 ma-0">
        <v-col class="pt-1 pa-0">
          <HbTextField
            :class="{'custom-field-error' : errors.first('ref_name')}"
            hide-details
            :value= "payment.ref_name"
            v-validate="'required'"
            data-vv-name="ref_name"
            data-vv-as="Reference Name"
            :error-messages="errors.collect('ref_name')"
            label="Reference Name*"
            id="gift-card-name"
            name="gift-card-name"
            autocomplete="gift-card-ref-name"
            full
            @input="handleInputUpdate('payment', 'ref_name', $event)"
            backgroundColor=""
            >
          </HbTextField>
        </v-col>
      </v-row>
      <v-row class="pa-0 ma-0" v-if="payment_type && payment_type.toLowerCase() === PAYMENTS.PAYMENT_METHODS.GIFTCARD.VALUE">
        <v-col cols="12" class="custom-label pa-0 mt-3 mb-1" :class="{'error-label'  : errors.has('number')}">Reference Number:</v-col>
        <v-col class="pa-0 ">
          <HbTextField
            box
            hide-details
            :value="payment.number"
            v-validate="payment_type === PAYMENTS.PAYMENT_METHODS.GIFTCARD.VALUE ? 'required' : ''"
            data-vv-name="number"
            data-vv-as="Reference Number"
            :error-messages="errors.collect('number')"
            label="Reference Number*"
            id="reference-number"
            name="reference-number"
            autocomplete="reference-number"
            full
            @input="handleInputUpdate('payment', 'number', $event)"
            @blur="$validator.validate('number')"
            >
          </HbTextField>
        </v-col>
      </v-row>

      <v-row no-gutters class="pa-0 mt-3 mb-3">
        <v-col>
          <v-textarea
            :class="{'custom-field-error' : errors.first('notes')}"
            hide-details
            :value="payment.notes"
            data-vv-name="notes"
            :error="errors.has('notes')"
            label="Notes"
            id="gift-notes"
            name="gift-notes"
            autocomplete="cc-gift-notes"
            full
            @input="handleInputUpdate('payment', 'notes', $event)"
            backgroundColor=""
            rows="1"
            auto-grow
          >
        </v-textarea>
        </v-col>
      </v-row>
        </v-col>

      </v-row>
      

    </v-container>


  </div>
</template>


<script type="text/babel">

    import PaymentMethodBase from './PaymentMethodBase.vue';
    import { EventBus } from '../../../EventBus';
    import { mapGetters, mapMutations } from "vuex";
    import {PAYMENTS} from '@/constants/payments.js';

    export default {
        extends: PaymentMethodBase,
        data() {
            return {
            }
        },
        components:{},
        computed:{
          ...mapGetters({
            paymentConfig: 'paymentsStore/getPaymentSourceConfig',
            getErrors: 'paymentsStore/getErrors',
            paymentData: 'paymentsStore/getPaymentInformation',
            payment_method: 'paymentsStore/getPaymentMethod',
            contact: 'paymentsStore/getContact',
            payment: 'paymentsStore/getPayment',
        })
        },
        created(){
            this.PAYMENTS = PAYMENTS;
        },
        destroyed() {
        },
        props: ['payment_type'],
        methods:{
          ...mapMutations({
            setCheckErrors: 'paymentsStore/setCheckErrors',
            setPaymentInformation: 'paymentsStore/setPaymentInformation',
            setPayment: 'paymentsStore/setPayment',
            setPaymentMethod: 'paymentsStore/setPaymentMethod',
          }),
          handleInputUpdate : _.debounce(async function(obj ,property_name, property_value) {
            if(obj === 'payment_information'){
              this.setPaymentInformation({property: property_name, propertyValue: property_value});
            }
            if(obj === 'payment'){
              this.setPayment({property : property_name, propertyValue: property_value});
            }
          }, 200),

          validateFields(){
            return this.$validator.validateAll();
          }
        },
        watch:{
            
        }
    }
</script>
<style scoped>
.custom-label{
    font-size: 12px;
    font-weight: 400;
    color: #637381;
  }
.error-label{
   color: #ff5252;
}
</style>